const { remarkTypograf } = require("./remark-typograf");

module.exports = remarkTypograf;
